import { render, staticRenderFns } from "./ApplicationOrder.vue?vue&type=template&id=38cfc2c2&scoped=true&"
import script from "./ApplicationOrder.vue?vue&type=script&lang=js&"
export * from "./ApplicationOrder.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationOrder.vue?vue&type=style&index=0&id=38cfc2c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cfc2c2",
  null
  
)

export default component.exports